import { useEffect, useState } from 'react'

export const useTabsPrêmios = (disponivel: string | null) => {
  // Estado para controlar a tab ativa
  const [activeTab, setActiveTab] = useState(() => {
    if (disponivel === 'true') return 'available'
    if (disponivel === 'false') return 'unavailable'
    if (disponivel === null || disponivel === undefined) return 'available'
    return 'available' // Padrão: tab "Disponíveis" selecionada
  })

  // Flag para controlar se já foi inicializado
  const [isInitialized, setIsInitialized] = useState(false)

  // Determina qual tab está ativa baseado no parâmetro de disponibilidade
  const getActiveTab = () => {
    if (disponivel === 'true') return 'available'
    if (disponivel === 'false') return 'unavailable'
    if (disponivel === null || disponivel === undefined) return 'available'
    return 'available' // Padrão: tab "Disponíveis" selecionada
  }

  // Atualiza a tab ativa quando os parâmetros da URL mudarem
  useEffect(() => {
    if (isInitialized) {
      const newActiveTab = getActiveTab()
      setActiveTab(newActiveTab)
    }
  }, [disponivel, isInitialized])

  // Inicializa se não houver parâmetros
  useEffect(() => {
    if (!isInitialized) {
      setIsInitialized(true)
    }
  }, [isInitialized])

  return {
    activeTab,
    setActiveTab,
    isInitialized,
  }
}
